const AmplifyConfig = {
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_57o0UO1Cp",
    "aws_user_pools_web_client_id": "7cdk0bbmlriabr1apo2br84o0g"
};

export default AmplifyConfig;